class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    const inner = this.querySelector('.drawer__inner');
    if (inner && inner.classList.contains('is-empty')) {
      inner.classList.remove('is-empty');
    }
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (!sectionElement) return;
      const html = parsedState.sections && parsedState.sections[section.id];
      if (!html) return;
      const newInner = this.getSectionInnerHTML(html, section.selector);
      if (newInner) sectionElement.innerHTML = newInner;
    });

    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const found = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return found ? found.innerHTML : '';
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* ============================================================
   POOPY CART DRAWER ADDITIONS
   Add at the bottom of assets/cart-drawer.js
   ============================================================ */

/* =================================================================
   POOPY CART DRAWER — custom additions
   All interactive features use event delegation so they survive
   Dawn renderContents() re-renders without stacking listeners.
   ================================================================= */
(function () {
  'use strict';

  /* One-time registration flags */
  var giftsInitDone       = false;
  var carouselInitDone    = false;
  var carouselAtcInitDone = false;

  /* ---------------------------------------------------------------
     GIFTS GROUP — delegated, registers once
     --------------------------------------------------------------- */
  function initGiftsGroup() {
    if (giftsInitDone) return;
    giftsInitDone = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.pcd__gifts-head');
      if (!btn) return;
      var group = btn.closest('.pcd__gifts-group');
      if (!group) return;
      var isOpen = group.classList.toggle('pcd__gifts-group--open');
      btn.setAttribute('aria-expanded', String(isOpen));
    });
  }

  /* ---------------------------------------------------------------
     CAROUSEL — delegated arrows + touch, index stored on track el
     initCarousel() called each re-render to reset to page 0.
     --------------------------------------------------------------- */
  function renderCarousel(track) {
    var index = track._pcdIndex || 0;
    var pages = track.querySelectorAll('.pcd__carousel-page');
    track.style.transform = 'translateX(-' + (index * 100) + '%)';
    var prev = document.getElementById('pcd-carousel-prev');
    var next = document.getElementById('pcd-carousel-next');
    if (prev) prev.disabled = (index === 0);
    if (next) next.disabled = (index === pages.length - 1);
    var dotsWrap = document.getElementById('pcd-carousel-dots');
    if (dotsWrap) {
      dotsWrap.querySelectorAll('.pcd__dot').forEach(function (d, i) {
        d.classList.toggle('pcd__dot--active', i === index);
      });
    }
  }

  function initCarousel() {
    var track = document.getElementById('pcd-carousel-track');
    if (track) {
      track._pcdIndex = 0;
      renderCarousel(track);
    }
    if (carouselInitDone) return;
    carouselInitDone = true;

    document.addEventListener('click', function (e) {
      var t = document.getElementById('pcd-carousel-track');
      if (!t) return;
      var pages = t.querySelectorAll('.pcd__carousel-page');
      if (e.target.closest('#pcd-carousel-prev')) {
        if (t._pcdIndex > 0) { t._pcdIndex--; renderCarousel(t); }
        return;
      }
      if (e.target.closest('#pcd-carousel-next')) {
        if (t._pcdIndex < pages.length - 1) { t._pcdIndex++; renderCarousel(t); }
        return;
      }
    });

    document.addEventListener('touchstart', function (e) {
      var vp = e.target.closest('.pcd__carousel-viewport');
      if (vp) vp._pcdTouchX = e.touches[0].clientX;
    }, { passive: true });

    document.addEventListener('touchend', function (e) {
      var vp = e.target.closest('.pcd__carousel-viewport');
      if (!vp || vp._pcdTouchX === undefined) return;
      var t = document.getElementById('pcd-carousel-track');
      if (!t) return;
      var dx = e.changedTouches[0].clientX - vp._pcdTouchX;
      var pages = t.querySelectorAll('.pcd__carousel-page');
      if (dx < -40 && t._pcdIndex < pages.length - 1) { t._pcdIndex++; renderCarousel(t); }
      else if (dx > 40 && t._pcdIndex > 0) { t._pcdIndex--; renderCarousel(t); }
    });
  }

  /* ---------------------------------------------------------------
     CAROUSEL ADD TO CART — capture, registers once
     --------------------------------------------------------------- */
  function initCarouselAddToCart() {
    if (carouselAtcInitDone) return;
    carouselAtcInitDone = true;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pcd-addon]');
      if (!btn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();

      /* pcd__add-btn has data-variant-id; pcd__sheet-cta gets it from the sheet state */
      var variantId = btn.dataset.variantId || btn.dataset.sheetVariantId;
      if (!variantId) return;

      var textEl    = btn.querySelector('.pcd__add-btn-text');
      var spinnerEl = btn.querySelector('.pcd__add-btn-spinner');

      btn.disabled = true;
      btn.classList.add('pcd__add-btn--loading');
      if (spinnerEl) spinnerEl.hidden = false;
      if (textEl)   textEl.hidden = true;

      var cart = document.querySelector('cart-drawer');
      if (!cart) return;

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: 1 }],
          sections: cart.getSectionsToRender().map(function (s) { return s.id; }),
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (response) {
          if (response.errors) {
            btn.disabled = false;
            btn.classList.remove('pcd__add-btn--loading');
            if (spinnerEl) spinnerEl.hidden = true;
            if (textEl) textEl.hidden = false;
            return;
          }
          if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: variantId });
          }

          /* Re-render the drawer with the freshly-returned sections.
             Wrapped so a render error can't leave the UI stale — on failure
             we re-fetch the drawer section directly as a fallback. */
          var rendered = false;
          try {
            if (response.sections && response.sections['cart-drawer']) {
              var cartObj = Object.assign(
                {},
                response.items ? response.items[0] : response,
                { sections: response.sections }
              );
              cart.renderContents(cartObj);
              cart.classList.remove('is-empty');
              /* Confirm the drawer really shows the filled state. If the
                 section HTML didn't apply (selector mismatch, stale markup),
                 the drawer still has .is-empty content — treat as not rendered
                 so the fallback fetch below runs. */
              var stillEmpty = !!document.querySelector('#CartDrawer .pcd__empty');
              rendered = !stillEmpty;
            }
          } catch (err) {
            rendered = false;
          }

          if (!rendered) {
            var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
            var sectionUrl = rootPath.replace(/\/$/, '') + '/?section_id=cart-drawer';
            fetch(sectionUrl)
              .then(function (r) { return r.text(); })
              .then(function (html) {
                var newDrawer = new DOMParser()
                  .parseFromString(html, 'text/html')
                  .querySelector('#CartDrawer');
                var current = document.querySelector('#CartDrawer');
                if (newDrawer && current) {
                  current.innerHTML = newDrawer.innerHTML;
                  cart.classList.remove('is-empty');
                  cart.open && cart.open();
                }
              })
              .catch(function () {});
          }

          /* SVG-icon buttons (bestsellers): the icon lives inside textEl, so we
             must NOT overwrite textContent. Use an explicit text-label class to
             know whether a "✓" swap is safe. */
          btn.disabled = false;
          btn.classList.remove('pcd__add-btn--loading');
          if (spinnerEl) spinnerEl.hidden = true;
          var hasTextLabel = btn.classList.contains('pcd__add-btn--has-label');
          if (textEl) {
            textEl.hidden = false;
            if (hasTextLabel) textEl.textContent = '\u2713';
          }
          btn.classList.add('pcd__add-btn--added');
          setTimeout(function () {
            btn.classList.remove('pcd__add-btn--added');
            if (textEl && hasTextLabel) textEl.textContent = '+ Voeg toe';
          }, 2000);
        })
        .catch(function () {
          btn.disabled = false;
          btn.classList.remove('pcd__add-btn--loading');
          if (spinnerEl) spinnerEl.hidden = true;
          if (textEl) textEl.hidden = false;
        });

    }, true); /* useCapture */
  }

  /* ---------------------------------------------------------------
     DELIVERY DATE
     --------------------------------------------------------------- */
  function updateDeliveryDate() {
    setTimeout(function () {
      /* Only rendered for NL/BE (snippets/cart-drawer.liquid); other EU
         countries get a static "3-10 werkdagen" server-side and never
         reach this code. */
      var el = document.getElementById('pcd-delivery-instock');
      if (!el || el.textContent.trim() !== '') return;
      var now    = new Date();
      var nlTime = new Date(now.toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' }));
      var hour   = nlTime.getHours();
      /* Localized strings come from Liquid (snippets/cart-drawer.liquid) —
         JS-injected text bypasses the Weglot proxy, so it can't be hardcoded.
         Dutch fallbacks kept for safety. */
      var months     = (el.getAttribute('data-dd-months') || 'jan,feb,mrt,apr,mei,jun,jul,aug,sep,okt,nov,dec').split(',');
      var rangeLabel = el.getAttribute('data-dd-range') || '1-3 werkdagen';
      /* Skip Sunday only — Saturday is a delivery day */
      function addDeliveryDays(d, n) {
        var r = new Date(d), a = 0;
        while (a < n) { r.setDate(r.getDate() + 1); if (r.getDay() !== 0) a++; }
        return r;
      }
      /* 1-3 workday promise: earliest = next delivery day (one later after
         the 12:00 NL cutoff or on Sunday), latest = earliest + 2 delivery days.
         Output: "1-3 werkdagen · 6 - 8 okt" (or "30 sep - 2 okt" across months). */
      var n = hour < 12 ? 1 : 2;
      if (nlTime.getDay() === 0) n++; /* Sunday: no same-day shipping */
      var from = addDeliveryDays(nlTime, n);
      var to   = addDeliveryDays(from, 2);
      var range = (from.getMonth() === to.getMonth())
        ? from.getDate() + ' - ' + to.getDate() + ' ' + months[to.getMonth()]
        : from.getDate() + ' ' + months[from.getMonth()] + ' - ' + to.getDate() + ' ' + months[to.getMonth()];
      el.textContent = rangeLabel + ' \u00b7 ' + range;
    }, 80);
  }

  /* ---------------------------------------------------------------
     INIT
     --------------------------------------------------------------- */
  /* ---------------------------------------------------------------
     MOBILE INFO BOTTOM-SHEET
     Desktop: CSS :hover tooltip. Mobile: JS bottom-sheet.
     --------------------------------------------------------------- */
  var sheetInitDone = false;
  function initInfoSheet() {
    if (sheetInitDone) return;
    sheetInitDone = true;

    function isTouch() {
      return !window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    }

    function openSheet(trigger) {
      var sheet    = document.getElementById('pcd-sheet');
      var backdrop = document.getElementById('pcd-sheet-backdrop');
      if (!sheet) return;

      /* Populate content */
      var nameEl  = document.getElementById('pcd-sheet-name');
      var metaEl  = document.getElementById('pcd-sheet-meta');
      var bodyEl  = document.getElementById('pcd-sheet-body');
      var imgEl   = document.getElementById('pcd-sheet-img');
      var ctaBtn  = document.getElementById('pcd-sheet-cta');

      if (nameEl) nameEl.textContent = trigger.dataset.sheetTitle || '';
      if (metaEl) metaEl.textContent = trigger.dataset.sheetMeta  || '';
      if (bodyEl) bodyEl.textContent = trigger.dataset.sheetBody  || '';

      /* Benefits list */
      var benefitsEl = document.getElementById('pcd-sheet-benefits');
      var b1 = trigger.dataset.sheetBenefit1 || '';
      var b2 = trigger.dataset.sheetBenefit2 || '';
      var b3 = trigger.dataset.sheetBenefit3 || '';
      if (benefitsEl) {
        var hasAny = b1 || b2 || b3;
        benefitsEl.hidden = !hasAny;
        var spans = benefitsEl.querySelectorAll('li');
        var texts = [b1, b2, b3];
        spans.forEach(function (li, idx) {
          var span = li.querySelector('span');
          if (texts[idx]) {
            if (span) span.textContent = texts[idx];
            li.hidden = false;
          } else {
            li.hidden = true;
          }
        });
      }

      /* Product image */
      var imgSrc = trigger.dataset.sheetImg || '';
      if (imgEl) {
        if (imgSrc) {
          imgEl.innerHTML = '<img src="' + imgSrc + '" alt="" width="48" height="48" style="width:100%;height:100%;object-fit:contain;">';
        } else {
          imgEl.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 21V9"/></svg>';
        }
      }

      /* Wire up CTA button with this product's variant */
      if (ctaBtn) {
        ctaBtn.dataset.sheetVariantId = trigger.dataset.sheetVariant || '';
        var textEl = ctaBtn.querySelector('.pcd__add-btn-text');
        if (textEl) {
          if (trigger.dataset.sheetMeta) {
            /* Price lives in its own excluded span so Weglot never converts it */
            textEl.textContent = '';
            textEl.appendChild(document.createTextNode('+ Voeg toe voor '));
            var priceSpan = document.createElement('span');
            priceSpan.setAttribute('data-wg-notranslate', '');
            priceSpan.textContent = trigger.dataset.sheetMeta;
            textEl.appendChild(priceSpan);
          } else {
            textEl.textContent = '+ Voeg toe';
          }
        }
      }

      requestAnimationFrame(function () {
        sheet.classList.add('pcd__sheet--open');
        backdrop.classList.add('pcd__sheet-backdrop--visible');
      });
    }

    function closeSheet() {
      var sheet    = document.getElementById('pcd-sheet');
      var backdrop = document.getElementById('pcd-sheet-backdrop');
      if (!sheet) return;
      sheet.classList.remove('pcd__sheet--open');
      backdrop.classList.remove('pcd__sheet-backdrop--visible');
    }

    /* Open on mobile only */
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('.pcd__info-trigger');
      if (!trigger) return;
      if (!isTouch()) return; /* desktop: CSS tooltip handles it */
      e.preventDefault();
      e.stopPropagation();
      openSheet(trigger);
    });

    /* Close */
    document.addEventListener('click', function (e) {
      if (e.target.closest('#pcd-sheet-close') ||
          e.target.id === 'pcd-sheet-backdrop' ||
          e.target.closest('#pcd-sheet-backdrop')) {
        closeSheet();
      }
    });
  }

  function pcdInit() {
    initGiftsGroup();
    initCarousel();
    initCarouselAddToCart();
    initInfoSheet();
    updateDeliveryDate();
  }

  function observeCartDrawer() {
    var target = document.getElementById('CartDrawer');
    if (!target) return;

    /* Debounce so rapid sequential mutations (e.g. gift app adding multiple
       items) only trigger pcdInit once after the dust settles. */
    var debounceTimer = null;
    function debouncedInit() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        initCarousel(); /* re-read track + reset index, listener already registered */
        updateDeliveryDate();
      }, 50);
    }

    new MutationObserver(function (mutations) {
      /* Fire on any childList change anywhere inside CartDrawer —
         subtree:true catches both renderContents (#CartDrawer innerHTML swap)
         and CartDrawerItems updates (.drawer__inner innerHTML swap). */
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].type === 'childList' && mutations[i].addedNodes.length) {
          debouncedInit();
          break;
        }
      }
    }).observe(target, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    pcdInit();
    observeCartDrawer();
  });

  document.addEventListener('shopify:section:load', pcdInit);
  window.pcdInit = pcdInit;
})();